import { get } from "lodash";
import { useSelector } from "react-redux";

export default function useEntity(entity, id) {
  return useSelector((state) => get(state.entities[entity], `byId[${id}]`, undefined));
}
